/**
 * /about — who runs Yedding, with AboutPage and Person structured data.
 *
 * The words live in src/content/about.js and the layout lives in
 * src/components/About. Nothing here but the route's entry point, which is
 * the same shape every other page in this folder uses.
 *
 * See docs/aeo/AEO-LEDGER.md, task 11a.
 */

import About from '../components/About';

const PageAbout = () => <About />;

export default PageAbout;
